import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

// Components
import Modal from '../modal';
import IconSadFace from '../utils/icons/sadFace';

// CSS
import './error.css';

// actions
import * as actions from '../../actions/index';

class ErrorModal extends Component {
  constructor(props) {
    super(props);
    this.onClose = this.onClose.bind(this);
  }
  onClose() {
    this.props.removeError();
    if (this.props.callback) {
      this.props.callback();
    }
  }
  render() {
    return (
      <Modal
        showModal={this.props.show}
        onClose={this.onClose}
        className="apa-modal-error"
        dismissText="Tentar novamente"
        dismissQaId="button-try-again">
        <div className="modal-error">
          <IconSadFace fill="#d15239" />
          <h4>Bah...</h4>
          <p>Tivemos um probleminha e não conseguimos ir adiante...</p>
        </div>
      </Modal>
    );
  }
}

ErrorModal.propTypes = {
  removeError: PropTypes.func,
  callback: PropTypes.any,
  show: PropTypes.bool
};

export default compose(connect(state => ({
  authenticated: state.UserReducer.authenticated,
  uuid: state.SessionReducer.uuid,
}), {
  ...actions
}))(ErrorModal);
